import { Component, inject } from '@angular/core';
import { DxTabsComponent } from 'devextreme-angular';
import { AccessType, AuthService, PermissionType } from '@services';
import { AppointmentAgingScoreComponent } from './appointment-aging-score/appointment-aging-score.component';
import { InboundProductivityScoreComponent } from './inbound-productivity-score/inbound-productivity-score.component';
import { TagsRequiredScoreComponent } from './tags-required-score/tags-required-score.component';
import { AppointmentComplianceScoreComponent } from './appointment-compliance-score/appointment-compliance-score.component';

type TabKey = 'appointmentAging' | 'inboundProductivity' | 'tagsRequired' | 'appointmentCompliance';

@Component({
    selector: 'app-appointment-score',
    imports: [
        DxTabsComponent,
        AppointmentAgingScoreComponent,
        InboundProductivityScoreComponent,
        TagsRequiredScoreComponent,
        AppointmentComplianceScoreComponent,
    ],
    templateUrl: './appointment-score.component.html',
})
export class AppointmentScoreComponent {
    private auth = inject(AuthService);

    get showAppointmentAging(): boolean {
        return this.auth.checkPermission(PermissionType.AppointmentAgingScore, AccessType.Manage);
    }

    get showInboundProductivity(): boolean {
        return this.auth.checkPermission(PermissionType.InboundProductivityScore, AccessType.ViewOnly);
    }

    get showTagsRequired(): boolean {
        return this.auth.checkPermission(PermissionType.TagsRequiredScore, AccessType.Manage);
    }

    get showAppointmentCompliance(): boolean {
        return this.auth.checkPermission(PermissionType.AppointmentComplianceScore, AccessType.ViewOnly);
    }

    
    selectedTab: TabKey = (
        [
            { visible: this.showAppointmentAging, key: 'appointmentAging' },
            { visible: this.showInboundProductivity, key: 'inboundProductivity' },
            { visible: this.showTagsRequired, key: 'tagsRequired' },
        ] as { visible: boolean; key: TabKey }[]
    ).find((tab) => tab.visible)?.key ?? 'appointmentCompliance';

    allTabs = [
        { key: 'appointmentAging', text: 'Appointment Aging', icon: '', permission: PermissionType.AppointmentAgingScore },
        { key: 'inboundProductivity', text: 'Inbound Productivity', icon: '', permission: PermissionType.InboundProductivityScore },
        { key: 'tagsRequired', text: 'Tags Required', icon: '', permission: PermissionType.TagsRequiredScore },
        { key: 'appointmentCompliance', text: 'Compliance', icon: '', permission: PermissionType.AppointmentComplianceScore },
    ];

    tabs = this.allTabs.filter((t) => this.auth.checkPermission(t.permission, AccessType.ViewOnly));
}
